import PositionTableHead from './PositionTableHead';
import { TableWrapper, LoadingSpacer, ButtonsWrapper } from './Table.styles';

function TR() {
  return (
    <tr>
      <td>
        <LoadingSpacer />
      </td>
      <td>
        <LoadingSpacer />
      </td>
      <td>
        <LoadingSpacer />
      </td>
      <td>
        <LoadingSpacer />
      </td>
      <td>
        <LoadingSpacer />
      </td>
      <td>
        <LoadingSpacer />
      </td>
      <td>
        <ButtonsWrapper>
          <button>Details</button>
          <button>Close</button>
        </ButtonsWrapper>
      </td>
    </tr>
  );
}
export default function LoadingTable() {
  return (
    <TableWrapper>
      <section>
        <table>
          <PositionTableHead />
          <tbody>
            <TR />
            <TR />
            <TR />
          </tbody>
        </table>
      </section>
    </TableWrapper>
  );
}
